import React from "react";

export const ColTreeContext = React.createContext();
